/*
 * Project: LegalPlace assistant
 * File: src/app/actions.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpActionsWindow {
  constructor() {
    this.last_action = 'NOTHING_BOX';
    this.la_arg1 = '';
    this.la_arg2 = '';
  }

  trackAction(action, arg1 = '', arg2 = '') {
    this.last_action = action;
    this.la_arg1 = arg1;
    this.la_arg2 = arg2;
  }
}

export default LpActionsWindow;



// WEBPACK FOOTER //
// ./src/app/actions.js